import React, {memo} from "react"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../components/SubMenu"
import iconLogs from "../../../../assets/images/icons/settings/log.png"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"

export const LogScreen = memo(function LogScreen() {
    return (
        <PasswordContainer requiredRole="admin" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings"}>
                <div className="content-divider">
                    <SubMenuComponent icon={iconLogs} name={"Kullanıcı Logları"} path={"/settings/logs/user-logs"} />
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
